export enum OrderEventStatus {
  Placed = 100,
  Processing = 150,
  Accepted = 200,
  Loading = 300,
  Dispatched = 400,
  Fulfilled = 500,
  Cancelled = 600,
  Returned = 700,
}

export const OrderEventStatusMap: { [key: number]: string } = {
  [OrderEventStatus.Placed]: 'Placed',
  [OrderEventStatus.Processing]: 'Processing',
  [OrderEventStatus.Accepted]: 'Accepted',
  [OrderEventStatus.Loading]: 'Loading',
  [OrderEventStatus.Dispatched]: 'Dispatched',
  [OrderEventStatus.Fulfilled]: 'Fulfilled',
  [OrderEventStatus.Cancelled]: 'Cancelled',
  [OrderEventStatus.Returned]: 'Returned',
};
